import React, { useEffect, useState } from "react";
import Header from "../component/Header";
import Sidebar from "../component/Sidebar";
import { AesDecrypt } from "../middleware/AesDecrypt";
import { AesEncrypt } from "../middleware/AesEncrypt";
import axios from "axios";
import { Base_url, Base_url_bbbs } from "../config";
import { useNavigate } from "react-router-dom";

import ReactDOM from "react-dom";
import ReactPaginate from "react-paginate";
import bigInt from "big-integer";

let Refer = () => { 
  let [data, setData] = useState();
 

  let navigate = useNavigate();
  let [value, inputvalue] = useState();
  const [text, setText] = useState("");
  const [ refdata , setRefdata ] = useState();
  const [ refdatas , setRefdatas ] = useState();
  const [ counts , setCountdata ] = useState();
  let [indexs, setIndex] = useState(1);

  let [indexss, setIndexs] = useState(1);
  const [ refercounts , setReferCountdata ] = useState();

  const [ refdatareal , setRefdatareal ] = useState();

  useEffect(() => {
    Start();
    RewardDeath()
  }, []);

  let Start = async () => {
    let token = await localStorage.getItem("token");
    if (token === undefined || token === null || token === "") {
      navigate("/login");
    }
  };

  let RewardDeath = async () => { 

    try {
      let token = await localStorage.getItem("token");

      let pp = { token , page : 1 , limit : 10 };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/referr" ,
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data , 
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          setRefdata(dat.data)
          setCountdata(dat.data.count)

          setRefdatas(dat.data.fiineuser)
          
          setRefdatareal(dat.data.fineusercount[0].totalUsersWithRefereduser)

        })
        .catch((ee) => {});
    } catch (err) {}
  };

  let handlePageClick = async (event) => {
    console.log(event.selected);
    setIndex(event.selected+1);

    try {
      let token = await localStorage.getItem("token");

      let pp = { token , page : event.selected+1 , limit : 10 };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/referr" ,
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data , 
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          setRefdata(dat.data)
          setCountdata(dat.data.count)
 
        })
        .catch((ee) => {});
    }catch (err) {
      console.log(err , 'errerrerrerrerrerr')
    }

  }


   let handlePageClicks = async (event) => {
    console.log(event.selected);
    setIndexs(event.selected+1);

    try {
      let token = await localStorage.getItem("token");

      let pp = { token , page : event.selected+1 , limit : 10 };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/referr" ,
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data , 
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );

          // setRefdata(dat.data)
          setRefdatas(dat.data.fiineuser)
          // setCountdata(dat.data.count)
           setRefdatareal(dat.data.fineusercount[0].totalUsersWithRefereduser)
 
        })
        .catch((ee) => {});
    }catch (err) {
      console.log(err , 'errerrerrerrerrerr')
    }

  }
  

  let cliikkk = async (dd) => {
    try {
      let token = await localStorage.getItem("token");

      let pp = { token , id : dd?.id };
      let data = await AesEncrypt(pp);

      let apicall = await axios({
        method: "post",
        url: Base_url + "/admin2/referrdata" ,
        data: pp,
      })
        .then((dat) => {
          console.log(
            dat.data , 
            "Jsson dddddddddddddddddddddddddddddddddddddddddd "
          );
 
 
        })
        .catch((ee) => {});
    }catch (err) {
      console.log(err , 'errerrerrerrerrerr')
    }
  }
 
  return (
    <div>
      <div className="row">
        <Header />
        <div
          className="col-10"
          style={{ 
          }}
        >
          <p style={{ fontWeight : '700' , fontSize : 20 }} >Refer</p>

          <div className="row mt-4" >
            <div className='col-5' >

              <div > 
              <table class="table">
              <thead class="thead-dark" style={{  top : 50 , backgroundColor : '#fff' , }}>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Wallet Amount</th>
                  <th scope="col">Redeem Amount</th> 
                  <th scope="col">Name</th> 
                </tr>
              </thead>
              <tbody>
                {
                  refdata?.data?.map((dd, key) => {

                    let walletamount = 0
                    dd?.waletret?.map(( dd , keyyy ) =>{
                      walletamount = walletamount + Number( dd?.amount )
                    })

                    return(
                      <tr   onClick={()=>{
                         cliikkk(dd)
                      }} >
                       <th style={{ cursor : 'pointer' , paddingTop : 20 , fontWeight : '400' ,  }} >
                       {key + (indexs-1) * 10 + 1}
                       </th>

                       <th  style={{ cursor : 'pointer' , paddingTop : 20 , }} >
                         { dd?.amount }
                       </th>
                       <th style={{ cursor : 'pointer' , paddingTop : 20 , }}  >
                       { walletamount }
                       </th>
                       <th  style={{ cursor : 'pointer' , paddingTop : 20 , }}  >
                       { dd?.user?.name }
                       </th>
                      </tr> 
                    )
                  })
                }
                </tbody>
                </table>              </div>

              <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                pageCount={counts / 10}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                containerClassName="pagination justify-content-center"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                breakClassName="page-item"
                breakLinkClassName="page-link"
              />
            </div>
            <div className='col-7' >


               <ReactPaginate
                breakLabel="..."
                nextLabel="next >"
                onPageChange={handlePageClicks}
                pageRangeDisplayed={3}
                pageCount={refdatareal  / 10}
                previousLabel="< previous"
                renderOnZeroPageCount={null}
                containerClassName="pagination justify-content-center"
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                activeClassName="active"
                breakClassName="page-item"
                breakLinkClassName="page-link"
              />


              <div > 
                <table class="table">
                <thead class="thead-dark" style={{   top : 50 , backgroundColor : '#fff' , }}>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Name</th> 
                    <th scope="col">Phone</th> 
                    <th scope="col">Refer User Count</th>
                    <th scope="col">Refer User id</th> 
                    
                  </tr>
                </thead>
                <tbody> 
                  {
                   refdatas?.map((dd, key) => {
                      return (
                        <tr  key={key}>
                          <th style={{ cursor: 'pointer', paddingTop: 20, fontWeight: '400' }}>
                            {key + (indexss - 1) * 10 + 1}
                          </th>

                          <th onClick={() => {
                              navigate("/useralldetail", { state: dd });
                            }}  style={{ cursor: 'pointer', paddingTop: 20 }}>
                            {dd?.name}
                          </th>

                          <th style={{ cursor: 'pointer', paddingTop: 20 }}>
                            {dd?.phoneno}
                          </th>

                          <th style={{ cursor: 'pointer', paddingTop: 20 }}>
                            {dd?.refereduser?.length || 0}
                          </th>

                          <th style={{ cursor: 'pointer', paddingTop: 20 }}>
                          {(() => {
                            const filteredItems = Array.isArray(dd?.refereduser) 
                              ? dd.refereduser.filter(item => item.amount > 0)
                              : [];
                            
                            const count = filteredItems.length;
                            const totalAmount = filteredItems.reduce((sum, item) => sum + item.amount, 0);
                            
                            return (
                              <div>
                                <div>Count: {count}</div>
                                <div>Earn Total Amount: {totalAmount}</div>
                              </div>
                            );
                          })()}
                        </th>
                        </tr>
                      );
                    })
                  }

                </tbody>
              </table>              
              </div>

                {/* <ReactPaginate
                  breakLabel="..."
                  nextLabel="next >"
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  pageCount={refdatareal / 10}
                  previousLabel="< previous"
                  renderOnZeroPageCount={null}
                  containerClassName="pagination justify-content-center"
                  pageClassName="page-item"
                  pageLinkClassName="page-link"
                  previousClassName="page-item"
                  previousLinkClassName="page-link"
                  nextClassName="page-item"
                  nextLinkClassName="page-link"
                  activeClassName="active"
                  breakClassName="page-item"
                  breakLinkClassName="page-link"
                />
                 */}
            </div> 
          </div>
        </div>
      </div>
    </div>
  );
};

export default Refer;
